import StepperModule from './stepper.module'

export default StepperModule
